module.exports = __webpack_public_path__ + "static/media/dl_screens_icon.6aca15b2.svg";